export type ScriptType =
  | 'P2SH'
  | 'P2WSH'
  | 'P2PKH'
  | 'P2WPKH'
  | 'P2TR'
  | 'P2SH-P2WPKH'
  | 'P2SH-P2WSH'
  | 'coinbase';

export interface AutocompleteResult {
  type: 'address' | 'transaction' | 'note';
  value: string;
  note?: string;
}

export interface AddressData {
  address: string;
  scriptType: string;
  amt: number;
  amtUsd: number;
}

export interface Attribution {
  _id: string;
  id: string;
  address_type: ScriptType;
  balance: number;
  beneficial_owner: string;
  cluster_id: string;
  custodian: string;
  entity: string;
  display_name?: string;
  entity_type?: string;
  reserved?: boolean;

  cluster_size?: number;
  cluster_balance?: number;

  // high confidence cluster data
  hc_entity?: string;
  hc_grp?: string;

  total_sent?: number;
  total_received?: number;
}

export enum EAttributionField {
  Entity = 'entity',
  BeneficialOwner = 'benificial-owner',
  Custodian = 'custodian',
}

export enum ERuleType {
  Manual = 'manual',
  Incoming = 'incoming',
  Outgoing = 'outgoing',
}

export interface AttributionProposal {
  address: string;
  entity: string; // canonical
  note?: string;
  user?: string;
  isHCCluster?: boolean;
  rules?: ERuleType[];
  field?: EAttributionField;
}

export interface Filters {
  startDate?: string;
  endDate?: string;
  minInputAmount?: number;
  maxInputAmount?: number;
  minOutputAmount?: number;
  maxOutputAmount?: number;
  minBlockHeight?: number;
  maxBlockHeight?: number;
}

export interface Input {
  addr: string;
  amt: number;
  cp_type: number;
  n: number;
  intxid?: string;
}

export type Output = Input;
export type BitcoinTransactionItem = Input;

export interface PaginatedModel<T> {
  docs: T[];
  totalDocs: number;
  limit: number;
  totalPages: number;
  page: number;
  pagingCounter: number;
  hasPrevPage: boolean;
  hasNextPage: boolean;
  prevPage: number | null;
  nextPage: number | null;
}

export interface QueryParams {
  page?: number;
  limit?: number;
  sort?: string;
}

export interface Transfer {
  _id: string;
  id: string;
  block: number;
  timestamp: string;
  transfer_class: string;
  inamt: number;
  outamt: number;
  input_cnt: string;
  output_cnt: string;
  txfee: number;
  coinjoin: string;
  cpin: Input[];
  cpout: Output[];
}

export type TxHeader = 'address' | 'amt' | 'cluster' | 'n' | 'script';

export enum EUserTier {
  FREE = 'free',
  TRIAL = 'trial',
  DEVELOPER = 'developer',
  BUSINESS = 'business',
  PRO = 'pro',
  ENTERPRISE = 'enterprise',
  INTERNAL = 'internal',
}

export interface User {
  firstName: string;
  lastName: string;
  email: string;
  company?: string;
  password?: string;
  isVerified?: boolean;
  accountType?: EUserTier;
}

export interface AuthUser extends User {
  token: string;
}

export interface BitcoinAddressSummaryStats {
  totalReceived: number;
  totalSent: number;
  txCount: number;
  firstSeen: string;
}
